import { addMinutes, format } from "date-fns";
import { DateTime } from "luxon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SessionTile from "../../components/SessionTile";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { userState } from "../../redux/reducers/userReducer";


import { TwButton, TwLoadingIcon } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForClasses } from "../../utils/confighelpers";


export default function UpcomingClassActivites() {
    const { addToast, } = useToast();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userReduxState = useSelector(userState);
    const dashboardReduxState = useSelector(dashboardState);
    const [loading, setLoading] = React.useState(false);

    const [scheduledClasses, setSceduledClasses] = React.useState([]);
    const [classList, setClassList] = React.useState([]);



    const handleSessionClick = async (id, classData) => {
        if (dashboardReduxState.calendarSessionId === id) {
            dispatch(dashboardActions.setCalendarSessionId(-1));
            dispatch(dashboardActions.setCalendarOpen(false));
            navigate("/home/dashboard");
            return;
        }
        addToast("Loading session details");
        const isPckg = classData.isPackage;
        const config = {
            method: "get",
            url: `${getUrlForClasses()}getScheduleDetail?scheduleclassId=${id}&isPackage=${isPckg}`,
        };
        dispatch(setGlobalLoading(true));
        const request = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                dispatch(dashboardActions.setCalendarClassData(classData));
                dispatch(dashboardActions.setCalendarSessionId(id));
                dispatch(dashboardActions.setCalendarSessionData(request.data.data));
                dispatch(dashboardActions.setViewSessionPage(true));
                // navigate("/dashboard/ViewSessionDetails");
                navigate("/myschedule/detail");
            }
        }
    };

    const upcomingSessionsApi = async () => {
        const scheduledClassesConfig = {
            method: "get",
            url: `${getUrlForClasses()}groupScheduledClass?listFor=${userReduxState.businessType}`,
        };
        dispatch(setGlobalLoading(true));
        const scheduledClassesRequest = await axiosInstance(scheduledClassesConfig);
        dispatch(setGlobalLoading(false));
        if (scheduledClassesRequest.status === 200) {
            let schedClasses = [];
            for (const item of scheduledClassesRequest.data.data) {
                const dtStart = DateTime.fromISO(item.classDate);
                const dtEnd = format(addMinutes(dtStart.ts, item.duration), "HH:mm");

                let ticketQty = 0;
                let ticketsBooked = 0;

                if (item?.eventPricingList && item.eventPricingList.length > 0) {
                    item.eventPricingList.map((booking) => {
                        ticketQty = parseInt(ticketQty) + parseInt(booking.capacity);
                        ticketsBooked = parseInt(ticketsBooked) + parseInt(booking?.ticketsBooked ? booking.ticketsBooked.ticketsBookedConfirmed : 0);
                    })
                } else {
                    if (item.scheduleClassBookings && item.scheduleClassBookings.length > 0) {
                        ticketQty = item.capacity;
                        item.scheduleClassBookings.map((booking) => {
                            if (booking.status === "Cancelled") {
                                return booking;
                            }
                            if (booking.ticketsBought && booking.ticketsBought.length > 0) {
                                booking.ticketsBought.map((ticket) => {
                                    ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
                                })
                            } else {
                                ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
                            }
                        })
                    } else {
                        ticketQty = item.capacity;
                        ticketsBooked = item.participants.length;
                    }
                }

                let newClass = {
                    dataFor: "class",
                    id: item._id,
                    imgSrc: item.classPhoto,
                    title: item.className,
                    time: `${dtStart.toFormat("dd LLL, ccc, HH:mm")} - ${dtEnd}`,
                    venue: item?.location?.addressName ? item.location.addressName : `${item.location.houseNumber}, ${item.location.city}`,
                    totalSeats: item.capacity,
                    // seatsBooked: item.participants.length,
                    // seatsBookedPerc: (item.participants.length / item.capacity) * 100,
                    seatsBooked: ticketsBooked,
                    seatsBookedPerc: (ticketsBooked / ticketQty) * 100,
                    bookedPeople: item.participants,
                    popover: false,
                    sessionObj: item,
                };
                schedClasses.push(newClass);
            }
            setSceduledClasses([...schedClasses]);
        }
    };
    const getListOfClass = async () => {
        let mgClasses = [];
        const manageClassesConfig = {
            method: "get",
            url: `${getUrlForClasses()}listOfClasses?isPackage=${false}&listFor=${userReduxState.businessType}&onlyClassDetail=true`,
        };
        setLoading(true)
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        setLoading(false)
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.data.length) {
                for (const item of manageClassesRequest.data.data) {
                    mgClasses.push({
                        label: item.className,
                        id: item._id,
                        data: item
                    });
                }
                setClassList(mgClasses);
            }
        }
    };

    React.useEffect(() => {
        getListOfClass();
        upcomingSessionsApi();
    }, []);


    return (
        <div className={`max-w-7xl px-5 py-2 pb-10 bg-white rounded-2xl mt-16 `}>
            <div className={"flex flex-row justify-between items-center my-4"}>
                <h3 className={"font-extrabold text-brown-coffee text-lg sm:text-base md:text-base"}>
                    Upcoming Activities
                </h3>
                <p
                    className={"font-extrabold text-portland-orange text-sm cursor-pointer"}
                    onClick={(e) => {
                        navigate("/myclasses/myschedule", { replace: true });
                    }}
                >
                    View all
                </p>
            </div>
            {loading ? (
                <div className={"h-28 w-full grid place-items-center"}>
                    <TwLoadingIcon />
                </div>
            ) : Array.isArray(scheduledClasses) &&
                scheduledClasses.length > 0 ? (
                <div
                    className={
                        // "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2 sm:gap-4 overflow-x-auto"
                        "flex flex-col gap-5 sm:flex-row sm:gap-4 overflow-x-auto"
                    }
                >
                    {scheduledClasses.map((session, i) => (
                        <SessionTile
                            {...session}
                            key={i}
                            onClick={() =>
                                handleSessionClick(
                                    session.sessionObj.instanceId,
                                    session.sessionObj
                                )
                            }
                        />
                    ))}
                </div>
            ) : (
                <div className={`h-48 flex justify-center items-center`}>
                    {classList.length ? (<p className={"text-lg sm:text-2xl"}>
                        Your upcoming sessions will appear here
                    </p>) : (
                        <div className="flex flex-col gap-4 justify-center items-center w-full">
                            <div className="text-lg sm:text-2xl text-brown-coffee text-center">
                                No Upcoming Activities Configured
                            </div>
                            <TwButton
                                variant="orange"
                                className="sm:w-1/5"
                                onClick={() => {
                                    navigate("/myclasses/new");
                                }}
                            >
                                Add a new Class
                            </TwButton>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
